<template>
  <ViewComponentes :key="$route.params.viewId" />
</template>

<script>
import ViewComponentes from '@/views/view/ViewComponentes.vue'

export default {
  name: 'ViewComponentesWrapper',
  components: { ViewComponentes },
}
</script>
